import { Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { assistantShortcutLabel } from '@/lib/assistantShell'
import { preloadAssistantPanel } from './AssistantPanelSlot'
import { useAssistant } from './AssistantProvider'

export function AssistantButton() {
  const { enabled, open, toggle, triggerRef } = useAssistant()
  if (!enabled) return null
  const shortcut = assistantShortcutLabel()

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          ref={triggerRef}
          variant="toggle"
          size="sm"
          onClick={toggle}
          onPointerEnter={preloadAssistantPanel}
          onFocus={preloadAssistantPanel}
          aria-pressed={open}
          aria-label={open ? 'Fechar assistente' : 'Abrir assistente'}
          aria-keyshortcuts="Meta+J Control+J"
          className="gap-1.5 max-lg:w-9 max-lg:px-0"
        >
          <Sparkles className="text-primary" />
          <span className="hidden lg:inline">Assistente</span>
          <kbd className="hidden rounded-md border border-border bg-muted px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground lg:inline">
            {shortcut}
          </kbd>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom" className="flex items-center gap-2 text-xs lg:hidden">
        Assistente
        <kbd className="rounded border border-border px-1.5 py-0.5 font-mono text-[10px] text-muted-foreground">{shortcut}</kbd>
      </TooltipContent>
    </Tooltip>
  )
}
